// Lib
import React, { FC } from 'react';

// Util
import { registerDownloadSource } from '../../../../utils/fileDownloader/javascriptToSwiftFileDownloads';

// Components
import ModalToolbarButton from './ModalToolbarButton';
import DownloadButton from '../../../../components/buttons/DownloadButton';
import Icon from '../../../../components/icons/Icon';

// Styles
import './ModalToolbarShareButton.scss';

type ModalToolbarShareButtonProps = {
    url: string;
    filename: string;
    elementId: string;
};

const ModalToolbarShareButton: FC<ModalToolbarShareButtonProps> = ({ children, ...props }) => {
    return (
        <ModalToolbarButton className="ModalToolbarShareButton">
            <DownloadButton
                {...props}
                onDownloadStart={() => registerDownloadSource('.ModalToolbarShareButton')}
                isShare={true}
            >
                <Icon name="modal-toolbar-share" />
                <div className="text">{children}</div>
            </DownloadButton>
        </ModalToolbarButton>
    );
};

export default ModalToolbarShareButton;
